// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__L7d9E","title":"InfoRow_title__zthCP"};